<template>
  <div class="d-inline">
    <slot name="chatBtn">
      <button
          @click="scrollMessageToBottom"
        type="button"
        class="btn btn-sm btn-upper"
        style="background: #edeff6"
        data-toggle="modal"
        :data-target="`#${modalID}`"
      >
        <i class="flaticon2-chat"></i> Discuss
      </button>
    </slot>

    <!--Begin:: Chat-->
    <div
      class="modal scrollbar fade- modal-sticky-bottom-right"
      :id="modalID"
      role="dialog"
      data-backdrop="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="max-height:85vh">
          <div class="kt-chat">
            <div class="kt-portlet kt-portlet--last"  id="orderMessageModalBody">
              <div class="kt-portlet__head sticky-top bg-white">
                <div class="kt-chat__head ">
                  <div class="kt-chat__left">
                    <div class="kt-chat__label">
                      <!-- <p class="kt-chat__title">{{ user.first_name + ' ' + user.last_name }}</p>
                      <span class="kt-chat__status">
                        <span class="kt-badge kt-badge--dot kt-badge--success"></span> Active
                      </span> -->
                      <p class="kt-chat__title">Chat with Support</p>
                    </div>
                  </div>
                  <div class="kt-chat__right">
                    <button
                      type="button"
                      class="btn btn-clean btn-sm btn-icon"
                      data-dismiss="modal"
                    >
                      <i class="flaticon2-cross"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="kt-portlet__body" >
                <div
                  class="kt-scroll kt-scroll--pull  overflow-y-auto"
                  style="min-height:40vh"
                >
                  <div class="kt-chat__messages " >
                    <template v-for="message in messages">
                      <div
                        class="kt-chat__message"
                        :key="`msg-left-${message.id}`"
                        v-if="message.owner.id !== user.id"
                      >
                        <div class="kt-chat__user">
                          <a href="#" class="kt-chat__username">
                            {{
                              `${message.owner.first_name} ${message.owner.last_name}`
                            }}
                          </a>
                          <span class="kt-chat__datetime">
                            {{ message.created_at }}
                          </span>
                        </div>
                        <div class="kt-chat__text ">
                          {{ message.content }}
                          <div
                            v-if="message.file_name"
                            class="d-flex align-items-center bg-light rounded mt-2"
                          >
                            <div
                              style="background-color: #fdf1e5;"
                              class="px-3 m-2 py-2"
                            >
                              <i class="flaticon2-photograph"></i>
                            </div>
                            <div class="flex-grow-1 px-2 ml-4 text-left px-3 py-2">
                              {{ message.file_name }}
                            </div>
                            <a
                              @click.prevent="
                                download(
                                  message.id,
                                  message.file_name
                                )
                              "
                              href="#"
                              class="px-3 py-2 download-attachment-btn"
                              :disabled="downloadingAttachmentId === message.id"
                              style="position: relative;"
                            >
                              <template v-if="downloadingAttachmentId === message.id">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="vertical-align:middle;"></span>
                              </template>
                              <template v-else>
                                <i class="flaticon2-download"></i>
                              </template>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        class="kt-chat__message kt-chat__message--right"
                        :key="`msg-right-${message.id}`"
                        v-else
                      >
                        <div class="kt-chat__user">
                          <a href="#" class="kt-chat__username">You</a>
                          <span class="kt-chat__datetime">
                            {{ message.created_at }}
                          </span>
                        </div>
                        <div class="kt-chat__text kt-bg-light-brand">
                          {{ message.content }}
                          <div
                            v-if="message.file_name"
                            class="d-flex align-items-center bg-light rounded mt-2"
                          >
                            <div
                              style="background-color: #fdf1e5;"
                              class="px-3 m-2 py-2"
                            >
                              <i class="flaticon2-photograph"></i>
                            </div>
                            <div class="flex-grow-1 px-2 text-left px-3 py-2">
                              {{ message.file_name }}
                            </div>
                            <a
                              @click.prevent="
                                download(
                                  message.id,
                                  message.file_name
                                )
                              "
                              href="#"
                              class="px-3 py-2 download-attachment-btn"
                              :disabled="downloadingAttachmentId === message.id"
                              style="position: relative;"
                            >
                              <template v-if="downloadingAttachmentId === message.id">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="vertical-align:middle;"></span>
                              </template>
                              <template v-else>
                                <i class="flaticon2-download"></i>
                              </template>
                            </a>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="kt-portlet__foot p-3 sticky-bottom bg-white">
                <div class="kt-chat__input">
                  <div class="kt-chat__editor">
                    <input
                      type="file"
                      ref="file"
                      @change="change"
                      style="display: none;"
                    />
                    <textarea
                      style="height: 50px;"
                      placeholder="Type here..."
                      v-model="message"
                      :class="{ 'is-invalid': hasError('content') }"
                      @input="clearError('content')"
                      @keyup="ChangeSendButton"
                    ></textarea>
                    <div v-if="hasError('content')" class="invalid-feedback">
                      {{ getError("content").replace("content", "message") }}
                    </div>
                    <div
                      v-if="file"
                      class="kt-chat__text kt-bg-light-brand"
                      style="width: 40%;"
                    >
                      <div
                        class="d-flex align-items-center bg-light rounded mt-2"
                      >
                        <div
                          style="background-color: #fdf1e5;"
                          class="px-3 py-2"
                        >
                          <i class="flaticon2-photograph"></i>
                        </div>
                        <div class="flex-grow-1 px-2 text-left px-3 py-2">
                          {{ file.name }}
                        </div>
                        <a @click.prevent="remove" href="#" class="px-3 py-2">
                          <i class="flaticon2-delete"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="kt-chat__toolbar">
                    <div class="kt_chat__tools uploader-container">
                     <UppyUploader :orderId="$route.params.id"/>
                    </div>
                    <div class="kt_chat__actions">
                      <button
                        :disabled="readyToSend"
                        type="button"
                        class="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply"
                        id="order-message-reply-btn"
                        @click="submit"
                      >
                        reply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--ENd:: Chat-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ValidationErrorsMixin from "@/mixins/ValidationErrors.js";
import UppyUploader from "./UppyUploader.vue";

export default {
    name: "MessagesModal",
    mixins: [ValidationErrorsMixin],
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            errors: [],
            message: "",
            file: null,
            readyToSend: true,
            downloadingAttachmentId: null,
        };
    },    
    components: { UppyUploader },
    mounted(){

    },
    computed: {
        ...mapGetters({
            messages: "message/messages",
            user: "auth/user",
        }),
        modalID() {
            return `chat-modal-${this.order.id}`;
        },
        isSendingMsg() {
            return !!(this.message || this.file);
        },
    },
    created() {
        this.getAllMessage({
            id: this.order.id,
        }).catch(() => {
            this.$router.push({
                name: "home",
            });
        });
    },
    methods: {
        ...mapActions({
            getAllMessage: "message/getAllMessage",
            storeMessage: "message/storeMessage",
            downloadAttachment: "message/downloadAttachment",
        }),
        scrollMessageToBottom(){
          // scroll to bottom if message box is scrollable.
          setTimeout(() => {
            document.querySelector("#orderMessageModalBody").scrollIntoView({ behavior: 'smooth', block: 'end' });
          }, 500);
        },
        ChangeSendButton(event){
          let message =  event.target.value;
          if (!message.trim()) {
            this.readyToSend = true
          } else {
            this.readyToSend = false
          }
        },
        submit() {
            const data = new FormData();
            if (this.file) {
                data.append("attachment", this.file);
            }
            data.append("content", this.message);
            this.storeMessage({
                id: this.$route.params.id,
                data: data,
            })
                .then(() => {
                this.message = "";
                this.file = null;
                this.scrollMessageToBottom();
            })
                .catch((error) => {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                    return;
                }
                let message = "Something wents wrong!";
                if (error.response.data.errors.attachment) {
                    message = error.response.data.errors.attachment[0];
                }
                if (error.response.data.errors.content) {
                    message = error.response.data.errors.content[0];
                }
                this.$swal({
                    icon: "error",
                    title: "Oops...",
                    text: message,
                });
            });
        },
        upload() {
            this.file = null;
            this.$refs.file.click();
        },
        change(event) {
            this.file = event.target.files[0];
        },
        remove() {
            this.file = null;
        },
      async download(messageId, fileName) {
        if (this.downloadingAttachmentId !== null) {
            return;
          }

          this.downloadingAttachmentId = messageId;
            
            try {
                const response = await this.downloadAttachment({
                    orderId: this.$route.params.id,
                    messageId: messageId,
                });
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
            } catch (error) {
                this.$swal({
                    icon: "error",
                    title: "Oops...",
                    text: "Something wents wrong!",
                });
            } finally {
                this.downloadingAttachmentId = null;
            }
        },
    }
};
</script>

<style scoped>
.sticky-top {
  position: sticky !important;
  top: 0;
  z-index: 1020;
}
.sticky-bottom {
  position: sticky !important;
  bottom: 0;
  z-index: 1020;
}
.scrollbar::-webkit-scrollbar {
  width: 0.6em;
}
.scrollbar::-webkit-scrollbar,
.scrollbar::-webkit-scrollbar-thumb {
  overflow: visible;
  border-radius: 4px;
}
.scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}
.kt-chat .kt-chat__input .kt-chat__editor textarea.is-invalid {
  border: 1px solid !important;
  border-color: #fd397a !important;
}

/* Spinner for Bootstrap 4/5 style look. You may adjust for your UI kit or add the following if missing: */
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border .75s linear infinite;
          animation: spinner-border .75s linear infinite;
}

@-webkit-keyframes spinner-border {
  to { -webkit-transform: rotate(360deg); }
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}

.download-attachment-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.download-attachment-btn:disabled .spinner-border {
  display: inline-block;
}
</style>
